// extracted by mini-css-extract-plugin
export default {"RadioGroup-label":"RadioGroup_RadioGroup-label__Y8Frs"};